import { prefix } from './actions';

export const list = state => state[prefix].list;
export const listAdmin = state => state[prefix].listAdmin;
export const listSubscribe = state => state[prefix].listSubscribe;
export const lang = state => state[prefix].lang;
export const defaultLang = state => state[prefix].defaultLang;
